import { createContext, useContext, useState } from "react";

export const FundDetailsContext = createContext();

export const FundDetailsProvider = ({ children }) => {
  const [productDetail, setProductDetail] = useState(null);

  return (
    <FundDetailsContext.Provider value={{ productDetail, setProductDetail }}>
      {children}
    </FundDetailsContext.Provider>
  );
};

export const useFundDetailsContext = () => useContext(FundDetailsContext);
